namespace GeniuzPOS.InitialData {
    export namespace PsCustomerSurveyService {
        export const baseUrl = 'InitialData/PsCustomerSurvey';

        export declare function Create(request: Serenity.SaveRequest<PsCustomerSurveyRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PsCustomerSurveyRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PsCustomerSurveyRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PsCustomerSurveyRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "InitialData/PsCustomerSurvey/Create",
            Update = "InitialData/PsCustomerSurvey/Update",
            Delete = "InitialData/PsCustomerSurvey/Delete",
            Retrieve = "InitialData/PsCustomerSurvey/Retrieve",
            List = "InitialData/PsCustomerSurvey/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>PsCustomerSurveyService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
